import React from "react";
import { Paper } from '@mantine/core';

const PaperWrapper = ({ children, stateP = 'sm', stateMT = '0', stateMB = '0' }) => {
    return (
        <Paper
            p={stateP}
            mt={stateMT}
            mb={stateMB}
            sx={(tema) => ({
                backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4],
            })}
        >
            {children}
        </Paper>
    )
}

export default PaperWrapper;